import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export const PrimaryCreateButton = ({
  onClick,
  children,
  sx = {},
  ...props
}) => {
  return (
    <Button
      sx={{
        border: "1px solid",
        py: 0,
        px: 2,
        textTransform: "none",
        fontWeight: 600,
        ...sx,
      }}
      onClick={onClick}
      startIcon={<AddIcon size={2} />}
      {...props}
    >
      {children}
    </Button>
  );
};
